import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Replacement } from './components/Replacement';

const ReplaceDevice = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý thiết bị', path: '/devices' },
            { name: 'Thay thế thiết bị', path: '' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Replacement />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default ReplaceDevice;
